export class GameEvent {
    constructor(private _type: string, private readonly _properties: any = {}) {}
    
    get properties() {
        return this._properties;
    }
    get type() {
        return this._type;
    }
}